<template>
  <div v-if="isVisible" class="info-container">
    <div class="layout fill-height align-center px-3">
      <div class="text">
        Master Library<span v-show="$route.name === 'flows' || $route.name === 'chapters'">
          - Copy all slides of choosen {{ $route.name.replace('s', '') }} into your library</span
        >
      </div>
      <div v-show="$route.name === 'collection.flows'" class="ml-4">
        <v-btn
          :disabled="
            flowHasSlides ||
              ($store.state.flows &&
                $store.state.flows.active &&
                $store.state.flows.active.slides &&
                $store.state.flows.active.slides.length === 0)
          "
          small
          color="white"
          depressed
          @click="
            startLocalization({
              structure: $store.state.flows.active,
              slides: $store.state.flows.active.slides,
              type: 'flow'
            })
          "
        >
          Localize Flow
        </v-btn>
      </div>
      <div v-show="$route.name === 'collection.chapters'" class="ml-4">
        <v-btn
          :disabled="
            chapterHasSlides ||
              ($store.state.chapters &&
                $store.state.chapters.active &&
                $store.state.chapters.active.slides &&
                $store.state.chapters.active.slides.length === 0)
          "
          small
          color="white"
          depressed
          @click="
            startLocalization({
              structure: $store.state.chapters.active,
              slides: $store.state.chapters.active.slides,
              type: 'chapter'
            })
          "
        >
          Localize Chapter
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import localization from '@/mixins/localization-mixin';

export default {
  name: 'BaseInfoContainer',
  mixins: [localization],
  computed: {
    isVisible() {
      return this.$store.getters['localization/isMaster'];
    },
    flowHasSlides() {
      const flows = this.$store.state.flows;
      if (flows && flows.active) {
        return Object.keys(flows.active).length === 0;
      }

      return false;
    },
    chapterHasSlides() {
      const chapters = this.$store.state.chapters;
      if (chapters && chapters.active) {
        return Object.keys(chapters.active).length === 0;
      }

      return false;
    }
  }
};
</script>

<style scoped>
.info-container {
  height: 43px;
  width: 100%;
  z-index: 1001;
  position: absolute;
  margin-top: -43px !important;
  background-color: var(--salmon);
  color: white !important;
}
.text {
  font-family: 'Roboto', sans-serif;
  font-size: 14px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.29;
  letter-spacing: normal;
  color: #ffffff;
}
</style>
